import createCache from "@emotion/cache";
/**
 * Name of the cascade layer every emotion rule is wrapped in.
 *
 * The layer must be declared in the app's layer order statement (see
 * apps/webapp/src/styles/master.scss) directly BEFORE "utilities". Later layers
 * win, so emotion keeps beating the legacy sheets and only loses to Tailwind's
 * fi:* utilities.
 */
export const EMOTION_LAYER_NAME = "emotion";
/**
 * Rules that are invalid inside @layer, or already carry their own layering.
 * "@import" in particular throws in CSSOM when nested.
 */
const UNWRAPPABLE_AT_RULE = /^@(import|charset|namespace|layer)\b/;
/**
 * Creates an emotion cache whose rules land in the "emotion" cascade layer.
 *
 * Emotion injects plain, unlayered <style> tags at runtime. Unlayered CSS beats
 * every layered rule at any specificity, so an emotion style always outranked
 * the fi:* utilities in Tailwind's "utilities" layer - which is why component
 * overrides had to reach for tricks like "fi:[&&]:pl-11", and why even those
 * did not work. Wrapping emotion's output in a layer puts both sides back on
 * the same ladder, ordered by the statement in master.scss.
 *
 * The wrapping happens at the sheet level rather than through a stylis plugin
 * because emotion hands the sheet finished, flat rules - one @layer block per
 * rule is valid for both the text-node path (dev) and insertRule (speedy).
 */
export function createLayeredEmotionCache(options) {
    const cache = createCache(options);
    const insert = cache.sheet.insert.bind(cache.sheet);
    cache.sheet.insert = (rule) => insert(UNWRAPPABLE_AT_RULE.test(rule)
        ? rule
        : `@layer ${EMOTION_LAYER_NAME}{${rule}}`);
    return cache;
}
//# sourceMappingURL=emotion-layer-cache.js.map